import { styled } from "styled-components";

import { elementSpacingMixin } from "uikit/styles";

import { ICloseIconButtonProps } from "./types";

export const CloseIconButtonContainer = styled.button<ICloseIconButtonProps>`
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background-color: transparent;

  svg {
    width: inherit;
    height: inherit;
  }

  path {
    fill: ${({ theme }) => theme.colors.colorsNew.gray["500_main"]};
  }

  ${elementSpacingMixin}
`;
